import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MetricResult from './metric-result-model'
import {
  CreateMetricResultAsync,
  DeleteMetricResultAsync,
  LoadMetricResultsAsync,
} from './metricResult-thunk'
const initialState: metricResultSliceState = {
  metricResult: [],
  selected_metricResult: '',
  is_loading_metricResult: false,
  is_creating_metricResult: false,
  is_deleting_metricResult: false,
}
export interface metricResultSliceState {
  metricResult: MetricResult[]
  selected_metricResult?: string
  is_loading_metricResult: boolean
  is_creating_metricResult: boolean
  is_deleting_metricResult: boolean
}
export const metricResultSlice = createSlice({
  name: 'metricResult',
  initialState,
  reducers: {
    setSelectedmetricResult: (state, action) => {
      state.selected_metricResult = action.payload
    },
    clearStatemetricResult: (state) => {
      state.metricResult = []
      state.is_loading_metricResult = false
      state.is_creating_metricResult = false
      state.is_deleting_metricResult = false
    },
    mergemetricResult: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_metricResult = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.metricResult = merge(state.metricResult, payload) as any
        }
      }
    },

    add_metricResult: (state, action) => {
      if (action.payload) {
        state.metricResult = [...state.metricResult, action.payload]
      }
    },
    set_metricResult: (state, action) => {
      let { key, value, id } = action.payload
      state.metricResult = state.metricResult.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMetricResultsAsync.pending, (state) => {
      state.is_loading_metricResult = true
    })
    builder.addCase(LoadMetricResultsAsync.fulfilled, (state, action) => {
      state.is_loading_metricResult = false
      if (action.payload) {
        state.metricResult = action.payload
      }
    })
    builder.addCase(LoadMetricResultsAsync.rejected, (state) => {
      state.is_loading_metricResult = false
    })
    builder.addCase(CreateMetricResultAsync.pending, (state) => {
      state.is_creating_metricResult = true
    })
    builder.addCase(CreateMetricResultAsync.fulfilled, (state) => {
      state.is_creating_metricResult = false
    })
    builder.addCase(CreateMetricResultAsync.rejected, (state) => {
      state.is_creating_metricResult = false
    })
    builder.addCase(DeleteMetricResultAsync.pending, (state) => {
      state.is_deleting_metricResult = true
    })
    builder.addCase(DeleteMetricResultAsync.fulfilled, (state, action) => {
      state.is_deleting_metricResult = false
      if (state.metricResult) {
        state.metricResult = state.metricResult.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMetricResultAsync.rejected, (state) => {
      state.is_deleting_metricResult = false
    })

    builder.addCase(
      autoThunks.get_metric_results_for_cursor.pending,
      (state) => {
        state.is_loading_metricResult = true
      },
    )
    builder.addCase(
      autoThunks.get_metric_results_for_cursor.fulfilled,
      (state, action) => {
        state.is_loading_metricResult = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_metric_results_for_cursor.rejected,
      (state) => {
        state.is_loading_metricResult = false
      },
    )

    builder.addCase(autoThunks.on_view_preview_media.pending, (state) => {
      state.is_loading_metricResult = true
    })
    builder.addCase(
      autoThunks.on_view_preview_media.fulfilled,
      (state, action) => {
        state.is_loading_metricResult = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.on_view_preview_media.rejected, (state) => {
      state.is_loading_metricResult = false
    })

    builder.addCase(autoThunks.on_view_preview.pending, (state) => {
      state.is_loading_metricResult = true
    })
    builder.addCase(autoThunks.on_view_preview.fulfilled, (state, action) => {
      state.is_loading_metricResult = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.on_view_preview.rejected, (state) => {
      state.is_loading_metricResult = false
    })

    builder.addCase(autoThunks.on_watchings_media.pending, (state) => {
      state.is_loading_metricResult = true
    })
    builder.addCase(
      autoThunks.on_watchings_media.fulfilled,
      (state, action) => {
        state.is_loading_metricResult = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.on_watchings_media.rejected, (state) => {
      state.is_loading_metricResult = false
    })
  },
})

function handleResult(action: any, state: metricResultSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_metricResult = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.metricResult = merge(state.metricResult, payload) as any
    }
  }
}

export const {
  clearStatemetricResult,
  setSelectedmetricResult,
  set_metricResult,
  mergemetricResult,
  add_metricResult,
} = metricResultSlice.actions

export const get_metricResult =
  (id?: string) =>
  (state: {
    metricResult: {
      metricResult: MetricResult[]
    }
  }): MetricResult | null => {
    let temp = state?.metricResult?.metricResult?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.metricResult?.metricResult[0] || null
  }
export const get_selected_metricResult = (state: {
  metricResult: metricResultSliceState
}): MetricResult | null => {
  let id = state?.metricResult?.selected_metricResult
  let temp = state?.metricResult?.metricResult?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_metricResult = (state: {
  metricResult: {
    metricResult: MetricResult[]
  }
}): MetricResult[] => {
  let temp = state?.metricResult?.metricResult
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_metricResult_busy = (state: {
  metricResult: metricResultSliceState
}) => {
  return (
    state?.metricResult.is_deleting_metricResult ||
    state?.metricResult.is_loading_metricResult ||
    state?.metricResult.is_creating_metricResult
  )
}
export const is_deleting_metricResult_busy = (state: {
  metricResult: metricResultSliceState
}) => {
  return state?.metricResult.is_deleting_metricResult
}
export const is_loading_metricResult_busy = (state: {
  metricResult: metricResultSliceState
}) => {
  return state?.metricResult.is_loading_metricResult
}
export const is_creating_metricResult_busy = (state: {
  metricResult: metricResultSliceState
}) => {
  return state?.metricResult.is_creating_metricResult
}

export default metricResultSlice.reducer
